import React from "react";
import { useShop } from "../contexts/ShopContext";

export default function CartSyncStatus() {
  const { cartUpdating, cartError, retryCart } = useShop();
  if (cartError) return (
    <div role="alert" className="mb-4 rounded-xl border border-red-200 bg-red-50 p-3 text-sm text-red-700">
      <p>{cartError}</p>
      <button type="button" disabled={cartUpdating} onClick={retryCart} className="mt-2 font-semibold underline disabled:opacity-50">
        저장된 장바구니 다시 확인
      </button>
    </div>
  );
  if (cartUpdating) return <p role="status" className="mb-4 text-sm text-[#0071e3]">수량과 금액을 저장하고 있습니다.</p>;
  return null;
}
